"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.denormalizeEntitiesByPaths = exports.buildEntityMappingsFromPaths = void 0;
var buildSchemaUtils_1 = require("../buildSchemaUtils");
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var normalizr_1 = require("normalizr");
/*
    entityMapping is a structure like
     {
        Bar: {
            relatedCase: 'AppCase?REFONE'
        },
        AppCase: {
            processInstance: 'ProcessInstance?REFONE'
        }
    },
    of the form
    {
        [entityName]: {
            [fieldNameToExpand]: '<relatedEntity>?<dataType>'
        }
    }
*/
var buildEntityMappingsFromPaths = function (viewConfig, rootEntityType, paths, createRelatedEntitiesWithBackreferences) {
    if (createRelatedEntitiesWithBackreferences === void 0) { createRelatedEntitiesWithBackreferences = true; }
    var entities = {};
    paths.forEach(function (fexp) {
        var mappings = (0, buildSchemaUtils_1.getEntityRelationships)(viewConfig, rootEntityType, fexp);
        Object.keys(mappings).forEach(function (entityName) {
            if (!entities[entityName]) {
                entities[entityName] = {};
            }
            // field -> related entity]
            entities[entityName] = __assign(__assign({}, entities[entityName]), mappings[entityName]);
        });
    });
    if (createRelatedEntitiesWithBackreferences) {
        var relatedEntities = (0, flatMap_1.default)(Object.values(entities), function (fieldSet) {
            return Object.values(fieldSet).map(function (exp) { return exp.split('?')[0]; });
        });
        relatedEntities.forEach(function (relE) {
            var fieldsInRelE = Object.values(viewConfig.entities[relE].fields);
            var relExists = fieldsInRelE.filter(function (f) { return f.relatedEntity && entities[f.relatedEntity]; }); // fields relating to an existing entity
            relExists.forEach(function (f) {
                var _a;
                entities[relE] = __assign(__assign({}, entities[relE]), (_a = {}, _a[f.name] = "".concat(f.relatedEntity, "?").concat(f.dataType), _a));
            });
        });
    }
    return entities;
};
exports.buildEntityMappingsFromPaths = buildEntityMappingsFromPaths;
var denormalizeEntitiesByPaths = function (entities, paths, viewConfig, rootEntityType, rootEntityId) {
    var entityMappings = (0, exports.buildEntityMappingsFromPaths)(viewConfig, rootEntityType, paths, false);
    var builtSchema = (0, buildSchemaUtils_1.buildSchema)(entityMappings, viewConfig, true);
    if (!builtSchema[rootEntityType]) {
        builtSchema[rootEntityType] = new normalizr_1.schema.Entity(rootEntityType);
    }
    return (0, normalizr_1.denormalize)(rootEntityId, builtSchema[rootEntityType], entities);
};
exports.denormalizeEntitiesByPaths = denormalizeEntitiesByPaths;
//# sourceMappingURL=index.js.map